const title = 'Applicant'
export default [
  {
    path: 'applicant-document',
    name: 'applicant-document',
    component: () => import('@/views/pages/apply-document/ApplyDocumentOtm.vue'),
    meta: {
      pageTitle: `${title} Documents`,
      breadcrumb: [
        {
          text: `${title} Documents`,
          active: true,
        },
      ],
      resource: 'ApplicantDocument',
      isOtm: true,
      isInno: false,
    },
  },
  {
    path: 'applicant-document/:id',
    name: 'applicant-document-view',
    component: () => import('@/views/pages/apply-document/View.vue'),
    meta: {
      pageTitle: title,
      breadcrumb: [
        {
          to: { name: 'applicant-document' },
          text: `${title} Documents`,
          active: false,
        },
        {
          text: `${title} Document`,
          active: true,
        },
      ],
      isOtm: true,
      isInno: false,
      resource: 'ApplicantDocument',
    },
  },
]
